import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ThemeModule } from "theme";

import { SplashComponent } from "./splash.component";

import { MaterialModule } from "./../../material-module"
import { FormsModule, ReactiveFormsModule } from "@angular/forms";


@NgModule({
  imports: [
    CommonModule,
    ThemeModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  declarations: [
    SplashComponent
  ],
  entryComponents: [

  ]
})
export class SplashModule { }
